import { render, staticRenderFns } from "./Cart-company.vue?vue&type=template&id=019a3965"
import script from "./Cart-company.vue?vue&type=script&lang=js"
export * from "./Cart-company.vue?vue&type=script&lang=js"
import style0 from "./Cart-company.vue?vue&type=style&index=0&id=019a3965&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports